export default {
  namespaced: true,
  state: () => ({
    handlebars: {
      user: [
        {
          handlebar: "user_first_name",
          name: "Employee first name",
          description: "The first name of the active IDM user",
          sample: "<John>"
        },
        {
          handlebar: "user_last_name",
          name: "Employee last name",
          description: "The last name of the active IDM user",
          sample: "<Doe>"
        },
      ],
      venue: [
        {
          handlebar: "venue_id",
          name: "Venue id",
          description: "The IDM id of the venue",
          sample: "<venue_sample_id_1234>"
        },
        {
          handlebar: "venue_name",
          name: "Venue name",
          description: "The full name of the venue",
          sample: "<Party bar>"
        },
        {
          handlebar: "venue_short_name",
          name: "Venue short name",
          description: "A shortened version of the venue name",
          sample: "<alohaKbh>"
        },
        {
          handlebar: "venue_email",
          name: "Venue email",
          description: "The public email for the venue",
          sample: "<public-email@venue.com>"
        },
        {
          handlebar: "venue_phone",
          name: "Venue phone",
          description: "The public phone number for the venue",
          sample: "<+4512345678>"
        },
        {
          handlebar: "venue_website",
          name: "Venue website",
          description: "The public website for the venue",
          sample: "<https://test-website.com>"
        },
        {
          handlebar: "venue_openhours",
          name: "Venue opening hours",
          description: "The opening hours of the venue",
          sample: "Mon: 20-24\nTue: 20-02\nWed: 20-04"
        },
        {
          handlebar: "venue_openhours_html",
          name: "Venue opening hours (HTML)",
          description: "The opening hours of the venue, formattet for HTML",
          sample: "Mon: 20-24\nTue: 20-02\nWed: 20-04"
        },
        {
          handlebar: "venue_vat",
          name: "Venue VAT number",
          description: "The VAT number for the venue",
          sample: "<11223344>"
        },
        {
          handlebar: "venue_sms_unsub_phrase",
          name: "Venue unsub phrase",
          description: "A phrase the guest must write to unsubscribe from SMS",
          sample: "<Afmeld sms, skriv UNSUB alohaKbh til +4511223344>"
        },
      ],
      legalDocument: [
        {
          handlebar: "doc_revision_date",
          name: "Legal doc revision date",
          description: "Legal doc revision date",
          sample: "02/05/2022 12:36"
        },
        {
          handlebar: "doc_revision_number",
          name: "Legal doc revision number",
          description: "Legal doc revision number",
          sample: "15"
        },
        {
          handlebar: "doc_id",
          name: "Legal doc ID",
          description: "ID of the legal document",
          sample: "a4iga346aklgk235l612a"
        },
      ],
      guest: [
        {
          handlebar: "guest_first_name",
          name: "Guest first name",
          description: "The first name of the guest",
          sample: "<John>"
        },
        {
          handlebar: "guest_last_name",
          name: "Guest last name",
          description: "The last name of the guest",
          sample: "<Doe>"
        },
        {
          handlebar: "guest_email",
          name: "Guest email",
          description: "The email of the guest",
          sample: "<guest@email.com>"
        },
        {
          handlebar: "guest_phone",
          name: "Guest phone number",
          description: "The phone number of the guest",
          sample: "<12345678>"
        },
      ],
      venueGuest: [
        {
          handlebar: "venue_guest_unsub_link",
          name: "Consent (unsubscribe) link for venue",
          description: "A link where the guest can edit their consents for the given venue",
          sample: "<Venue unsub link here>"
        },
      ],
      dataControllers: [
        {
          handlebar: "data_controllers_list",
          name: "Data controllers list",
          description: "A fully formatted list of all data controllers",
          sample: "<Data controllers here>"
        },
      ],
      dataProcessor: [
        {
          handlebar: "data_processor",
          name: "Data processor",
          description: "Data processor information",
          sample: "<Data processor here>"
        },
      ],
      booking: [
        {
          handlebar: "booking_id",
          name: "Booking ID",
          description: "Booking ID based on trigger",
          sample: "BOOKING-174"
        },
        {
          handlebar: "booking_num_guests",
          name: "Number of guests",
          description: "Number of guests",
          sample: "5"
        },
        {
          handlebar: "booking_arrival_time",
          name: "Arrival time (hh:mm)",
          description: "Arrival time",
          sample: "13:35"
        },
        {
          handlebar: "booking_arrival_date_short",
          name: "Arrival date (dd/mm)",
          description: "Arrival date short",
          sample: "31/12"
        },
        {
          handlebar: "booking_arrival_date",
          name: "Arrival date (dd/mm/yyyy)",
          description: "Arrival date long",
          sample: "01/01/1995"
        },
        {
          handlebar: "booking_departure_time",
          name: "Departure time (hh:mm)",
          description: "Departure time",
          sample: "13:35"
        },
        {
          handlebar: "booking_departure_date_short",
          name: "Departure date (dd/mm)",
          description: "Departure date short",
          sample: "31/12"
        },
        {
          handlebar: "booking_departure_date",
          name: "Departure date (dd/mm/yyyy)",
          description: "Depareture date long",
          sample: "01/01/1995"
        },
      ],
      sendDate: [
        {
          handlebar: "send_date_full",
          name: "Send date (full)",
          description: "The send date in the format dd-mm-yyyy",
          sample: "<24-09-2022>"
        },
        {
          handlebar: "send_date_day",
          name: "Send date (day)",
          description: "The send date in the format 'Monday', 'Tuesday', etc",
          sample: "<Wednesday>"
        }
      ]
    }
  }),
  getters: {
    getFor: state => function () {
      let result = [];

      for (let i = 0; i < arguments.length; i++) {
        if (state.handlebars.hasOwnProperty(arguments[i])) {
          result = result.concat(state.handlebars[arguments[i]]);
        }
      }

      return result;
    },
  }
};
